(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aaa-studio-gallery"] && !Shopify.designMode) return;
  try {
    
  // One delegated listener and one dialog for the whole document, however many
  // galleries a page carries. Bundled per section type, so this runs once.
  (function () {
    if (window.__aaaStudioGallery) return;
    window.__aaaStudioGallery = true;

    var dialog = null;
    var imgEl = null;
    var capEl = null;
    var prevBtn = null;
    var nextBtn = null;
    var countEl = null;
    var items = [];
    var index = 0;

    var ICON_CLOSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
    var ICON_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4l-8 8 8 8"/></svg>';
    var ICON_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4l8 8-8 8"/></svg>';

    function build() {
      dialog = document.createElement('dialog');
      dialog.className = 'aaa-studio-lightbox';
      dialog.setAttribute('aria-label', 'Enlarged image');
      dialog.innerHTML =
        '<figure class="aaa-studio-lightbox__figure">' +
        '<img class="aaa-studio-lightbox__img" alt="">' +
        '<figcaption class="aaa-studio-lightbox__caption"></figcaption>' +
        '</figure>' +
        '<button type="button" class="aaa-studio-lightbox__btn aaa-studio-lightbox__close" aria-label="Close">' + ICON_CLOSE + '</button>' +
        '<button type="button" class="aaa-studio-lightbox__btn aaa-studio-lightbox__prev" aria-label="Previous image">' + ICON_PREV + '</button>' +
        '<button type="button" class="aaa-studio-lightbox__btn aaa-studio-lightbox__next" aria-label="Next image">' + ICON_NEXT + '</button>' +
        '<p class="aaa-studio-lightbox__count"></p>';
      document.body.appendChild(dialog);

      imgEl = dialog.querySelector('.aaa-studio-lightbox__img');
      capEl = dialog.querySelector('.aaa-studio-lightbox__caption');
      prevBtn = dialog.querySelector('.aaa-studio-lightbox__prev');
      nextBtn = dialog.querySelector('.aaa-studio-lightbox__next');
      countEl = dialog.querySelector('.aaa-studio-lightbox__count');

      dialog.querySelector('.aaa-studio-lightbox__close').addEventListener('click', function () {
        dialog.close();
      });
      prevBtn.addEventListener('click', function () {
        show(index - 1);
      });
      nextBtn.addEventListener('click', function () {
        show(index + 1);
      });
      // Backdrop click: the dialog element's own box is the backdrop area,
      // so a click that did not land on the figure or a control closes it.
      dialog.addEventListener('click', function (event) {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('.aaa-studio-lightbox__figure, .aaa-studio-lightbox__btn')) return;
        dialog.close();
      });
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          show(index - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + 1);
        }
      });
      // Esc is handled by the dialog itself.
    }

    // The width the dialog will actually paint, in CSS pixels. The image is
    // contained inside min(96vw, 1600px) by 82dvh, so for a portrait picture
    // the HEIGHT is the binding constraint and the width needed is far smaller
    // than the viewport: about 500px for a 2:3 on a laptop. Working that out
    // here, rather than guessing in a sizes attribute, is what lets the
    // browser fetch a 1200px rendition instead of a 2200px one.
    //
    // CSS pixels, deliberately. sizes is a LAYOUT width: the browser applies
    // the device pixel ratio itself when it scores the candidates. Handing it
    // device pixels applied the ratio twice, so on a 2.2x screen a 529px frame
    // asked for 1164, the browser read that as layout and scored for 2561, and
    // every switch fetched the 2048 rendition, which is the very fetch this
    // function exists to avoid.
    function paintedWidth(el) {
      var ratio = parseFloat(el.getAttribute('data-ratio')) || 1.5;
      var maxW = Math.min(window.innerWidth * 0.96, 1600);
      var maxH = window.innerHeight * 0.82;
      return Math.ceil(Math.min(maxW, maxH * ratio));
    }

    // The candidate list the dialog chooses from, derived here rather than
    // rendered into the page. Shopify's image_url varies only the width
    // parameter, so the capped URL the block already carries is a template for
    // every other width: same file, same version, one number different. That
    // holds the markup to one URL and a number per image instead of a four
    // candidate list per image, which at fifty images was about 16KB of HTML
    // sent on every page view for a dialog most visitors never open. The
    // candidates it produces are byte for byte the ones Liquid used to write.
    var LB_WIDTHS = [900, 1200, 1600];
    var WIDTH_PARAM = /([?&]width=)\d+/;

    function atWidth(url, w) {
      return url.replace(WIDTH_PARAM, '$1' + w);
    }

    // Built once per image and kept on the element, so repeated passes through
    // a gallery cost one string each. A URL with no width parameter is not a
    // template for anything, so rather than offer the dialog three descriptors
    // pointing at one file, hand back nothing and let it use src alone.
    function srcsetFor(el) {
      if (el.__aaaSrcset !== undefined) return el.__aaaSrcset;
      var full = el.getAttribute('data-full') || '';
      var cap = parseInt(el.getAttribute('data-cap'), 10);
      var set = '';
      if (full && cap && WIDTH_PARAM.test(full)) {
        var parts = [];
        for (var i = 0; i < LB_WIDTHS.length; i++) {
          if (LB_WIDTHS[i] < cap) {
            parts.push(atWidth(full, LB_WIDTHS[i]) + ' ' + LB_WIDTHS[i] + 'w');
          }
        }
        parts.push(full + ' ' + cap + 'w');
        set = parts.join(', ');
      }
      el.__aaaSrcset = set;
      return set;
    }

    function applyTo(target, el) {
      var srcset = srcsetFor(el);
      target.sizes = paintedWidth(el) + 'px';
      if (srcset) target.srcset = srcset;
      target.src = el.getAttribute('data-full') || '';
    }

    // Warm the neighbours so a click is a cache hit rather than a round trip.
    // Same sizes and srcset as the real element, so the browser picks (and
    // stores) the identical candidate.
    function preload(i) {
      if (i < 0 || i >= items.length) return;
      var el = items[i];
      if (el.__aaaPreloaded) return;
      el.__aaaPreloaded = true;
      applyTo(new Image(), el);
    }

    function show(next) {
      if (next < 0 || next >= items.length) return;
      // Which way the viewer is travelling. Preloading one ahead is enough at
      // reading pace but not for someone holding the arrow down, where a click
      // can land before the neighbour has finished arriving; two ahead in the
      // direction of travel keeps the queue in front of them, and one behind
      // covers a change of mind.
      var dir = next >= index ? 1 : -1;
      index = next;
      var el = items[index];
      applyTo(imgEl, el);
      imgEl.alt = el.getAttribute('data-alt') || '';
      var caption = el.getAttribute('data-caption') || '';
      capEl.textContent = caption;
      capEl.hidden = caption === '';
      prevBtn.hidden = index === 0;
      nextBtn.hidden = index === items.length - 1;
      countEl.textContent = items.length > 1 ? index + 1 + ' / ' + items.length : '';
      preload(index + dir);
      preload(index + dir * 2);
      preload(index - dir);
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var trigger = event.target.closest('[data-aaa-gallery-open]');
      if (!trigger) return;
      var grid = trigger.closest('[data-aaa-gallery]');
      if (!grid) return;
      event.preventDefault();
      if (!dialog) build();
      items = Array.prototype.slice.call(grid.querySelectorAll('[data-aaa-gallery-open]'));
      show(items.indexOf(trigger));
      if (!dialog.open) dialog.showModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
